<template>
   <v-app>
  <div class="md-layout">
    <!-- <resizable-page> -->
    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
      <stats-card header-color="blue">
        <template slot="header">
          <div class="card-icon">
            <i class="fa fa-users"></i>
          </div>
          <p class="category">Driver Taxi</p>
          <h3 class="title">
            {{ drivertaxi }}
          </h3>
        </template>

        <template slot="footer">
          <div class="stats">
            <md-icon>update</md-icon>
            Current Total Active
          </div>
        </template>
      </stats-card>
    </div>
    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
      <stats-card header-color="blue">
        <template slot="header">
          <div class="card-icon">
            <i class="fa fa-users"></i>
          </div>
          <p class="category">Driver Black Plate</p>
          <h3 class="title">
            {{ driverblackplate }}
          </h3>
        </template>

        <template slot="footer">
          <div class="stats">
            <md-icon>update</md-icon>
            Current Total Active
          </div>
        </template>
      </stats-card>
    </div>
    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
      <stats-card header-color="green">
        <template slot="header">
          <div class="card-icon">
            <i class="fa fa-taxi"></i>
          </div>
          <p class="category">Vehicle Taxi</p>
          <h3 class="title">
            {{ total_vehicle_next_active }} / {{total_vehicle_next}}
          </h3>
        </template>

        <template slot="footer">
          <div class="stats">
            <md-icon>update</md-icon>
            Current Total Active
          </div>
        </template>
      </stats-card>
    </div>
    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
      <stats-card header-color="green">
        <template slot="header">
          <div class="card-icon">
            <i class="fa fa-taxi"></i>
          </div>
          <p class="category">Vehicle Black Plate</p>
          <h3 class="title">
            {{ total_vehicle_black_plate_active }} / {{total_vehicle_black_plate}}
          </h3>
        </template>

        <template slot="footer">
          <div class="stats">
            <md-icon>update</md-icon>
            Current Total Active
          </div>
        </template>
      </stats-card>
    </div>

    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
      <stats-card header-color="green">
        <template slot="header">
          <div class="card-icon">
            <i class="fa fa-taxi"></i>
          </div>
          <p class="category">Vehicle in Pool</p>
          <h3 class="title">
            {{ total_vehicle_in_pool }} / {{total_vehicle_in_out_pool}}
          </h3>
        </template>

        <!-- <template slot="footer">
          <div class="stats">
            <md-icon>update</md-icon>
            Current Total Active
          </div>
        </template> -->
      </stats-card>
    </div>

    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
      <stats-card header-color="green">
        <template slot="header">
          <div class="card-icon">
            <i class="fa fa-taxi"></i>
          </div>
          <p class="category">Vehicle outside Pool</p>
          <h3 class="title">
            {{ total_vehicle_out_pool }} / {{total_vehicle_in_out_pool}}
          </h3>
        </template>

        <!-- <template slot="footer">
          <div class="stats">
            <md-icon>update</md-icon>
            Current Total 
          </div>
        </template> -->
      </stats-card>
    </div>

    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
      <stats-card header-color="green">
        <template slot="header">
          <div class="card-icon">
            <i class="fa fa-taxi"></i>
          </div>
          <p class="category">Vehicle outside Pool</p>
          <h3 class="title">
            total dummy
          </h3>
        </template>

        <!-- <template slot="footer">
          <div class="stats">
            <md-icon>update</md-icon>
            Current Total 
          </div>
        </template> -->
      </stats-card>
    </div>

    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
      <stats-card header-color="green">
        <template slot="header">
          <div class="card-icon">
            <i class="fa fa-taxi"></i>
          </div>
          <p class="category">Vehicle On Service</p>
          <h3 class="title">
            {{ total_vehicle_in_service }}
          </h3>
        </template>

        <template slot="footer">
          <div class="stats">
            <md-icon>update</md-icon>
            Current Total 
          </div>
        </template>
      </stats-card>
    </div>

  
      <v-card class="md-layout-item md-layout">
    <v-card-title>
    SPJ Paid and Unpaid
    </v-card-title>
    <v-card-title> 
        <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        :return-value.sync="date_list"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="date_list_show"
            label="Month"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
            class="shrink"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="date_list"
          type="month"
          no-title
          scrollable
          
        >
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="menu = false"
          >
            Cancel
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="$refs.menu.save(date_list);changeDate();"
          >
            OK
          </v-btn>
        </v-date-picker>
      </v-menu>
      
        
      <v-spacer></v-spacer>
    </v-card-title>
      <div class="md-layout-item md-layout">

            <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50">
                <template>
                  <BarChart ref="barChartTaxi" :chart-data="chartDataTaxi" :chart-options="chartOptionsTaxi"  :plugins="pluginOptionsTaxi" />
                </template>
            </div>
            <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50">
              <template>
                <BarChart ref="barChartBlackPlate" :chart-data="chartDataBlackPlate" :chart-options="chartOptionsBlackPlate"  :plugins="pluginOptionsBlackPlate" />
              </template>
            </div>
        
      </div>
  </v-card>

  <template >
      <div>
<v-app>
          <!-- <router-link :to="{name: 'Detail Driver Black Plate', params: { id: item.id }}" class="btn btn-primary">Detail
          </router-link> -->
          <template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <!-- <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="red lighten-2"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Click Me
        </v-btn>
      </template> -->

      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Privacy Policy
        </v-card-title>

        <v-card-text>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            I accept
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
</v-app>

</div>

    </template>

      

      <!-- <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"
      >
        <chart-card
        :chart-data="taxiChart.data"
        :chart-options="taxiChart.options"
        :responsive-options="taxiChart.responsiveOptions"
        chart-type="Bar"
        chart-inside-header
        background-color="green"
        >
          <template slot="content">
            
            <p class="category">
              
              Payment Black Plate
            </p>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>access_time</md-icon>
              current data
            </div>
          </template>
        </chart-card>
      </div> -->
      
      <!-- </resizable-page> -->
  </div>

    
      </v-app>
</template>

<script>
// import Pagination from "@/components/Pagination";
import BarChart from '@/pages/Dashboard/Fms/DashboardBarChart.vue'
import vuetify from '@/plugins/vuetify';
import {
  ResizablePage,
  StatsCard,
  ChartCard,
  NavTabsCard
} from "@/components";

const toLower = text => {
  var rt = ""
    if(text){
       rt = text.toString().toLowerCase()
    }
    return rt
}
export default {
  vuetify,
  // props: {
  //   user: Object,
  // },
  components: {
    //  pagination: Pagination,
    // ResizablePage,
    StatsCard,
    // ChartCard,
    BarChart,
    // NavTabsCard
  },
 
  watch:{
    date_list: function(nv, ov) {
      this.date_list_show = this.$moment(nv, "YYYY-MM", true).format("MMMM YYYY")
    },
  } ,
  data() {
    return {
      dialog: false,
      componentKeyMenuRange: 0,
        componentKeyTable:0,
      menu: false,
      menu_range: false,
      modal: false,
      date_range_min: null,
       date_range_max: null,
        date_list: null,
        date_list_show: null,


        chartDataTaxi: {
        labels: [ 'Paid', 'Unpaid' ],
        datasets: [
          {
            label: 'Taxi',
            backgroundColor: ['#55f294','#f87979'],
            data: [0,0]
          },
          // {
          //   label: 'Data two',
          //   backgroundColor: '#f87979',
          //   data: [400000000000000]
          // }
        ]
      },
      chartOptionsTaxi: {
        responsive: true,
      },

      
      pluginOptionsTaxi: {
          legend: {
            display: false
          }
      },

      chartDataBlackPlate: {
        labels: [ 'Paid', 'Unpaid' ],
        datasets: [
          {
            label: 'Black Plate',
            backgroundColor: ['#55f294','#f87979'],
            data: [0,0]
          },
          // {
          //   label: 'Data two',
          //   backgroundColor: '#f87979',
          //   data: [400000000000000]
          // }
        ]
      },
      chartOptionsBlackPlate: {
        responsive: true,
      },

      
      pluginOptionsBlackPlate: {
          legend: {
            display: false
          }
      },

      
        drivertaxi:null,
        driverblackplate: null,
        driver:null,
        total_vehicle_next:null,
        total_vehicle_black_plate:null,
        total_vehicle_next_active:null,
        total_vehicle_black_plate_active:null,
        total_vehicle_in_pool:null,
        total_vehicle_out_pool:null,
        total_vehicle_in_out_pool:null,
        total_vehicle_in_service:null,
        taxiChart: {
          data: {
            labels: ['bb','aaa'],
            series: [
              [67],
              [23]
            ]
          },
          options: {
            low: 0,
            // hight: 800,
            showArea: false,
            height: '245px',
           scales: {
            xAxes: [{
                barThickness: 160,  // number (pixels) or 'flex'
                maxBarThickness: 108 // number (pixels)
            }]
        },
          },
           responsiveOptions: [
            ['screen and (max-width: 640px)', {
              xAxes: {
                barThickness: 160,  // number (pixels) or 'flex'
                maxBarThickness: 108 // number (pixels)
            },
              axisX: {
                labelInterpolationFnc (value) {
                  return value[10000]
                }
              }
            }]
          ]
        },
        rentalChart: {
          data: {
            labels: [],
            series: [
              [67, 152, 143, 240, 287, 335, 435, 437],
              [23, 113, 67, 108, 190, 239, 307, 308]
            ]
          },
          options: {
            low: 0,
            high: 800,
            showArea: false,
            height: '245px',
            axisX: {
              showGrid: false
            },
            lineSmooth: true,
            showLine: true,
            showPoint: true,
            fullWidth: true,
            chartPadding: {
              right: 50
            }
          },
          responsiveOptions: [
            ['screen and (max-width: 640px)', {
              axisX: {
                labelInterpolationFnc (value) {
                  return value[0]
                }
              }
            }]
          ]
        },
    }
  },

  created() {
      this.getData();
      this.date_list = this.$moment().format("YYYY-MM")
      this.getPaymentData()
    },
  methods: {

    async getData(){
        await this.$store.dispatch("fms_dashboard/driverActive")
        if(await this.$store.getters["fms_dashboard/dashboard"] && await Object.keys(this.$store.getters["fms_dashboard/dashboard"]).length!=0){
          this.driver = await this.$store.getters["fms_dashboard/dashboard"]
          this.drivertaxi = this.driver.total_driver_taxi_active
          this.driverblackplate = this.driver.total_driver_black_plate_active

        }

        await this.$store.dispatch("fms_dashboard/vehicleTaxiActive")
        if(await this.$store.getters["fms_dashboard/dashboard"] && await Object.keys(this.$store.getters["fms_dashboard/dashboard"]).length!=0){
          this.driver = await this.$store.getters["fms_dashboard/dashboard"]
          this.total_vehicle_next = this.driver.total_vehicle_next
          this.total_vehicle_next_active = this.driver.total_vehicle_next_active
          this.total_vehicle_black_plate = this.driver.total_vehicle_black_plate
          this.total_vehicle_black_plate_active = this.driver.total_vehicle_black_plate_active
        
        }

        await this.$store.dispatch("fms_dashboard/vehicleInOutPool")
        if(await this.$store.getters["fms_dashboard/dashboard"] && await Object.keys(this.$store.getters["fms_dashboard/dashboard"]).length!=0){
          var data = await this.$store.getters["fms_dashboard/dashboard"]
          this.total_vehicle_in_out_pool = data.total_vehicle
          this.total_vehicle_in_pool = data.total_vehicle_inside_pool
          this.total_vehicle_out_pool = data.total_vehicle_outside_pool
        
        }

        await this.$store.dispatch("fms_dashboard/vehicleInService")
        if(await this.$store.getters["fms_dashboard/dashboard"] && await Object.keys(this.$store.getters["fms_dashboard/dashboard"]).length!=0){
          var data = await this.$store.getters["fms_dashboard/dashboard"]
          this.total_vehicle_in_service = data.total_vehicle_service
        
        }
    },

    changeDate(){
     
      this.getPaymentData();
      this.clear_date_range();
    },

    changeDateRange(){
     
      this.filter_table();
    },

     clear_date_range() {
       this.componentKeyMenuRange += 1;
       this.date_range_list=null
       this.date_range_list_show=null
    },

    enumerateDaysBetweenDates (startDate, endDate){
        let date = []
        while(this.$moment(startDate) <= this.$moment(endDate)){
          date.push(startDate);
          startDate = this.$moment(startDate).add(1, 'days').format("YYYY-MM-DD");
        }
        return date;
      },

  filter_table(start,end){
      if(this.date_range_list[1]){
        var date_range = this.enumerateDaysBetweenDates(this.date_range_list[0],this.date_range_list[1])
      }
      else{
        var date_range = this.date_range_list[0]
      }
      this.list_column = ['Division', 'Name']
       this.list_column = this.list_column.concat(date_range); 
     
       this.componentKeyTable += 1;
      this.reset_table()
    },


    async getPaymentData() {
     
        await this.$store.dispatch("fms_dashboard/spjPaidunpaid",{ date: this.date_list });
      
        
       var data = await this.$store.getters["fms_dashboard/dashboard"];
       this.chartDataBlackPlate.datasets[0].data[0] = data.total_paid_black_plate
       this.chartDataBlackPlate.datasets[0].data[1] = data.total_unpaid_black_plate
       this.chartDataTaxi.datasets[0].data[0] = data.total_paid_taxi
       this.chartDataTaxi.datasets[0].data[1] = data.total_unpaid_taxi
       this.$refs.barChartBlackPlate.updateChart()    
       this.$refs.barChartTaxi.updateChart()     


    },
}
};
</script>
<style scoped>

</style>